import type { Theme, WithStyles } from "@envestnet/envreact-component-library";
import { createStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      maxWidth: "480px",
      padding: "40px 40px 0px 40px",
    },
    imageWrapper: {
      padding: 40,
      position: "fixed",
      left: 0,
      top: 0,
    },
    header4: {
      ...theme.fonts.h4,
      marginTop: 32,
      display: "flex !important",
      flexDirection: "row",
      color: theme.colors.textDefault,
    },
    textfield: {
      paddingTop: 18,
      "& > *": {
        textAlign: "left",
      },
    },
    label: {
      ...theme.fonts.label1,
      color: theme.colors.textSubtle,
      marginBottom: 16,
    },
    iconWrapper: {
      marginRight: 16,
    },
    cancel: {
      marginRight: 8,
      borderRadius: 0,
    },
    next: {
      borderRadius: 0,
    },
    footer: {
      display: "flex",
      flexDirection: "row-reverse",
      marginTop: "32px !important",
    },
    modalHeader: {
      ...theme.fonts.h4,
      color: theme.colors.textDefault,
      marginBottom: 0,
    },
    containerMfa: {},
    mfaItem: {},
    mfaSection: {},
    oktaVerify: { alignItems: "center", justifyContent: "center" },
    mfaCenter: {
      "& > div": {
        marginTop: "unset",
        width: "unset",
        minWidth: 360,
        marginBottom: "unset",
      },
    },
    noAuthenticatorsError: {
      fontFamily: "Red Hat Text",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "normal",
      marginTop: "10px",
      color: theme.colors.textDefault,
      "& span": {
        marginLeft: "5px",
      },
    },
    noAuthenticatorsErrorIcon: {
      color: theme.colors.error,
    },
    footerWithError: {
      display: "flex",
      flexDirection: "column",
      gap: "32px",
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
